import React from 'react';
import PropTypes from 'prop-types';
import VmGasModal from '../vm-gas-modal';
import UserFJMBaseContent from './UserFJMBaseContent';
import SecurityCheckRecord from './securityCheckRecord';

const TABS_BASE = 'gas-user-base';
const TABS_SECURITYCHECKRECORD = 'gas-user-security-check-record';

const UserFJMModal = ({ info, urlHead, ...resetProps }) => {
    const tabs = [
        {
            value: '详情',
            content: <UserFJMBaseContent info={info} urlHead={urlHead} />,
            key: TABS_BASE,
        },
        {
            value: '入户安检记录',
            content: <SecurityCheckRecord id={info.id} urlHead={urlHead} />,
            key: TABS_SECURITYCHECKRECORD,
        },
    ];
    return <VmGasModal tabs={tabs} title="用户（非居民）" {...resetProps} />;
};

UserFJMModal.propTypes = {
    info: PropTypes.object,
    urlHead: PropTypes.string,
};

export default UserFJMModal;
